export type AccountDetails = {
	id: number;
	number: string;
	type: string;
	billingType: string;
	status: string;
};

export type SingleInteractionLog = {
	interactionId: number;
	userAgent: string;
	clientIp: string;
	eventCode: string;
	amount: string | null;
	src: string | null;
	dst: string | null;
	account: AccountDetails;
};

export type InteractionDetailsResponse = {
	response: SingleInteractionLog;
};

const model: types.models.InputModel = {
	response: 'response',
};

export default model;
